<template>
  <div id="download" class="header-padding bg-light-grey">
    <header class="page-header ff ff-center horizontal-padding section-padding" style="padding-bottom: 0;">
      <div class="max-width">
        <h1>Download {{ downloadType }}</h1>
        <p>Select one of the {{ downloadType }} below to download it instantly.</p>
        <hr class="hr-100 hr-cyan">
      </div>
    </header>
    
    <section role="content" id="next-steps-content" class="horizontal-padding section-padding max-width" style="padding-top: 0;">
      <div class="content-block">
        <div v-if="isChrome" class="content-type-text">
          <div class="ff-12 warning-message border border-thin border-cyan half-padding">
            <div class="ff-columns ff-gap-1 ff-valign-center ff-content-center ff-text-left">
              <div class="ff-auto">
                <div style="width: 24px; height: 24px;">
                  <icon name="ui-warning" color="cyan" size=24 />
                </div>
              </div>
              <div class="ff-fill">
                <p><strong>Attention:</strong> Chrome's PDF viewer doesn't fully support editable forms. Once the file has finished downloading, please ensure that you are viewing the PDF in <em>Acrobat Reader</em> for full functionality.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="ff-12">
          <div class="ff-columns">
            
            <article v-for="(downloadLink,d) in downloadLinks" class="ff-12 ff-lg-6" :key="'download-'+d">
              <a :href="downloadLink.url" class="ff ff-nowrap ff-align-between bg-white tile">
                <div class="horizontal-padding half-vertical-padding black ff ff-valign-center">
                  {{ downloadLink.label }}
                </div>
                <div class="btn bg-cyan">
                  <icon name="icon-download" color="white" size=18 />
                  <span>Download</span>
                </div>
              </a>
            </article>
            
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "Download",
  props: [
    "articleSlug"
  ],
  data() {
    return {
      
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    downloadType() {
      var downloadType = '';
      
      if(this.articleSlug === 'request-forms'){
        downloadType = 'request forms';
      } else {
        downloadType = 'estimates';
      }
      
      return downloadType;
    },
    downloadLinks() {
      var downloadLinks = [];
      var calc = this.$store.state.calculator;
      var articleSlug = this.articleSlug;
      
      for(var e = 0; e < calc.estimates.length; e++) {
        var downloadParams = new URLSearchParams();
        
        downloadParams.append('type', calc.estimates[e].sampleType);
        downloadParams.append('qty', calc.estimates[e].sampleQty);
        downloadParams.append('id', e);

        var tests = '';
        var combos = '';
        
        // Tests params
        for(var t = 0; t < calc.estimates[e].tests.optimal.length; t++) {
          
          if(calc.estimates[e].tests.optimal[t].test_type === 1 && calc.estimates[e].tests.optimal[t].list_visibility === 0) {
            
            calc.estimates[e].tests.matches[t].forEach(function(subtest){
              tests += tests === '' ? subtest.test_id : ','+subtest.test_id;
              
              if(articleSlug === 'request-forms'){
                if(subtest.test_id >= 2 && subtest.test_id <= 6) {
                  combos += combos === '' ? subtest.test_id : ','+subtest.test_id;
                }
              }
              
            });
          } else {
            tests += tests === '' ? calc.estimates[e].tests.optimal[t].test_id : ','+calc.estimates[e].tests.optimal[t].test_id;
          }
          
        }
        
        if(tests){
          downloadParams.append('tests', tests);
        }
        
        // Request Forms
        if(articleSlug === 'request-forms'){
          if(combos){
            downloadParams.append('combos', combos);
          }
          
          downloadLinks.push({
            label: calc.estimates[e].displayedType+' Estimate ('+(e+1)+')',
            url:'/api/pdfs/request-form?'+downloadParams
          });
          
        // Estimates
        } else {
          downloadParams.append('price', calc.estimates[e].samplePrice);
          
          downloadLinks.push({
            label: calc.estimates[e].displayedType+' Estimate ('+(e+1)+')',
            url: '/api/pdfs/estimate?'+downloadParams
          });
        }
      }
      
      return downloadLinks;
    },
    isChrome() {  
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor); 
      return isChrome; 
    },
    meta() {
      var meta = {
        title: "Download",
        url: "https://www.csbplab.com.au/estimates/download/"+this.articleSlug,
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
  },
  mounted() {
    
  },
  methods: {
    
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>